import { Color, Engine, Font, Label, Vector, vec } from 'excalibur';
import { easeOutCubic } from '../utils/angles';
import { HAND_FONT } from '../utils/fonts';

export interface FloatingScoreOptions {
  name: string;
  text: string;
  pos: Vector;
  color: Color;
  size: number;
  rise?: number;
}

export class FloatingScore extends Label {
  private readonly startY: number;
  private readonly rise: number;
  private readonly duration = 1.15;
  private life = 0;

  constructor(options: FloatingScoreOptions) {
    super({
      name: options.name,
      text: options.text,
      pos: options.pos,
      anchor: vec(0.5, 0.5),
      font: new Font({ family: HAND_FONT, size: options.size, color: options.color }),
    });
    this.startY = options.pos.y;
    this.rise = options.rise === undefined ? 74 : options.rise;
    this.anchor = vec(0.5, 0.5);
    this.scale = vec(1.25, 1.25);
  }

  onPreUpdate(_engine: Engine, elapsed: number): void {
    const dt = elapsed / 1000;
    this.life += dt;
    const t = Math.min(1, this.life / this.duration);
    this.pos.y = this.startY - this.rise * easeOutCubic(t);
    this.opacity = 1 - t * t;
    const pop = 1 + 0.25 * Math.max(0, 1 - this.life / 0.16);
    this.scale = vec(pop, pop);
    if (t >= 1) {
      this.kill();
    }
  }
}
